import { useState } from "react";
import { Link } from "react-router-dom";

const footerLinks = {
  快速导航: [
    { label: "首页", path: "/" },
    { label: "AI美女写真", path: "/category/ai-meinv-xiezhen" },
    { label: "AI美女头像", path: "/category/ai-meinv-touxiang" },
    { label: "AI美女壁纸", path: "/category/ai-meinv-bizhi" },
    { label: "AI虚拟美女", path: "/category/ai-xuni-meinv" },
  ],
  帮助中心: [
    { label: "使用教程", path: "/article/ai-meinv-shengcheng-rumen" },
    { label: "提示词技巧", path: "/article/ai-meinv-tishici-jiqiao" },
    { label: "风格指南", path: "/article/ai-meinv-xiezhen-fengge" },
    { label: "常见问题", path: "/about" },
  ],
  关于我们: [
    { label: "品牌故事", path: "/about" },
    { label: "联系我们", path: "/about" },
    { label: "用户协议", path: "/about" },
    { label: "隐私政策", path: "/about" },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setStatusMsg("");

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setSubmitted(true);
      setSubmitting(false);
      return;
    }

    try {
      const res = await fetch(
        "https://readdy.ai/api/form/d9pmtt1n2trhb35gvi60",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(
            Array.from(formData.entries()).filter(
              ([k]) => k !== "website_alt"
            ) as [string, string][]
          ).toString(),
        }
      );
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(text);
      } catch {
        // not json
      }
      if (res.ok && (parsed as { code?: string }).code === "OK") {
        setSubmitted(true);
        setEmail("");
      } else {
        const msg =
          ((parsed as { meta?: { message?: string } }).meta?.message) ||
          ((parsed as { message?: string }).message) ||
          text;
        setStatusMsg(
          String(msg).includes("spam")
            ? "提交失败，请稍后再试。"
            : String(msg) || "提交失败，请稍后再试。"
        );
      }
    } catch {
      setStatusMsg("网络错误，请检查连接后重试。");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-semibold text-white">
                AI美学生成
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-sm">
              顶级AI图像生成技术，轻松生成高颜值AI美女写真、头像与壁纸。无需设计基础，输入描述即可秒出精美AI美女图像。
            </p>

            <div className="mt-6">
              <h4 className="text-sm font-medium text-white mb-3">
                订阅我们的资讯
              </h4>
              {submitted ? (
                <p className="text-sm text-accent-400 font-medium">
                  感谢订阅！我们会将最新资讯发送到您的邮箱。
                </p>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form
                  className="flex gap-2 max-w-sm"
                >
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="contact-honeypot"
                  />
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入您的邮箱"
                    required
                    className="flex-1 px-4 py-2.5 text-sm rounded-lg bg-background-800 border border-background-700 text-white placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="px-5 py-2.5 text-sm bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer font-medium disabled:opacity-60"
                  >
                    {submitting ? "提交中..." : "订阅"}
                  </button>
                  {statusMsg && (
                    <p className="text-xs text-red-400 mt-1">{statusMsg}</p>
                  )}
                </form>
              )}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-medium text-white mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} AI美学生成平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-white transition-colors duration-200 whitespace-nowrap"
              rel="nofollow"
            >
              用户协议
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-white transition-colors duration-200 whitespace-nowrap"
              rel="nofollow"
            >
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}